// @flow
import type {Node} from 'react'
import React from 'react'
import {graphql, useFragment} from 'react-relay'

import WYSIWYGTextareaWithFeatureFlag from 'components/ui/forms/WYSIWYGTextareaWithFeatureFlag'
import FormGroup from 'components/ui/FormGroup'
import {AutocompleteInput} from 'components/proposals/Part/ui'

import type {
  TensionBodyInput_circle$key as CircleKey,
  TensionBodyInput_circle as Circle,
} from './__generated__/TensionBodyInput_circle.graphql'
import type {
  TensionBodyInput_organization$key as OrganizationKey,
  TensionBodyInput_organization as Organization,
} from './__generated__/TensionBodyInput_organization.graphql'

type Props = $ReadOnly<{
  circle: ?CircleKey,
  organization: OrganizationKey,
  onChange: SyntheticInputEvent<*> => void,
  value: string,
  isReadonly: boolean,
}>

type FallbackInputProps = $ReadOnly<{
  circle: ?Circle,
  organization: Organization,
  onChange: SyntheticInputEvent<*> => void,
  value: string,
  isReadonly: boolean,
}>

function FallbackInput({circle, isReadonly, onChange, organization, value}: FallbackInputProps) {
  return (
    <FormGroup
      label={I18n.t('tensions.react.labels.your_tension')}
      target="tension-body"
      hideRightButton
    >
      { /* $FlowFixMe[incompatible-type] */ }
      { /* $FlowFixMe[incompatible-type-arg] */ }
      <AutocompleteInput
        id="tension-editor"
        circle={circle}
        className="form-control"
        disabled={isReadonly}
        name="tension"
        onChange={onChange}
        organization={organization}
        textarea
        value={value}
      />
    </FormGroup>
  )
}

const organizationFragment = graphql`
  fragment TensionBodyInput_organization on Organization {
    databaseId
    
    ...WYSIWYGTextareaWithFeatureFlag_organization
  }
`

const circleFragment = graphql`
  fragment TensionBodyInput_circle on Circle {
    databaseId
  } 
`

function TensionBodyInput({
  circle: circleKey,
  organization: organizationKey,
  onChange,
  value,
  isReadonly,
}: Props): Node {
  const organization = useFragment(organizationFragment, organizationKey)
  const circle = useFragment(circleFragment, circleKey)

  return (
    <WYSIWYGTextareaWithFeatureFlag
      mode="inline"
      value={value}
      onChange={onChange}
      label={I18n.t('tensions.react.labels.your_tension')}
      name="tension"
      organization={organization}
      fallbackComponent={FallbackInput}
      fallbackProps={{
        circle,
        isReadonly,
        onChange,
        organization,
        value,
      }}
    />
  )
}

export default TensionBodyInput
